// extracted by mini-css-extract-plugin
export default {"task-column":"TaskColumn_task-column__kB461","task-column-body":"TaskColumn_task-column-body__GHaCS"};